import {
  createSlice,
  createAsyncThunk,
  type PayloadAction,
} from "@reduxjs/toolkit";
import { gxnotifyViewApi } from "@/app/apiConfig/services/notificationsAbstractApiLayer";

export interface NotificationStoreItem {
  id: string;
  title: string;
  description: string;
  category: string;
  time: string;
  unread: boolean;
  actionRequired: boolean;
  rtpActionFlag?: string;
  actionId: number;
}

interface NotificationState {
  filteredNotifications: NotificationStoreItem[];
  dashboardUnread: NotificationStoreItem[];
  loading: boolean;
}

const initialState: NotificationState = {
  filteredNotifications: [],
  dashboardUnread: [],
  loading: false,
};

const formatTime = (dateString: string) =>
  new Date(dateString).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

export const fetchUnreadNotifications = createAsyncThunk(
  "notifications/fetchUnread",
  async () => {
    const response: any = await gxnotifyViewApi({
      pageNo: 1,
      pageSize: 10,
      type: "",
      status: "UNREAD",
    });

    return response.data.map((item: any) => ({
      id: String(item.notificationHistId),
      title: item.notificationSubject,
      description: item.notificationContent,
      category: item.categoryType,
      time: formatTime(item.time),
      unread: item.notificationStatus === "UNREAD",
      actionRequired: item.actionRequired === "Y",
      rtpActionFlag: item.rtpActionFlag,
      actionId: item.referenceEntityId,
    }));
  },
);

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setFilteredNotifications: (
      state,
      action: PayloadAction<NotificationStoreItem[]>,
    ) => {
      state.filteredNotifications = action.payload;
    },

    clearFilteredNotifications: (state) => {
      state.filteredNotifications = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUnreadNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUnreadNotifications.fulfilled, (state, action) => {
        state.dashboardUnread = action.payload;
        state.loading = false;
      })
      .addCase(fetchUnreadNotifications.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilteredNotifications, clearFilteredNotifications } =
  notificationSlice.actions;

export default notificationSlice.reducer;
